import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Meta from 'vue-meta'
import FontAwesome from '../static/css/fontawesome/fontawesome.min.css'
import "babel-polyfill"
// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'UA-66726120-3',
//   router,
//   autoTracking: {
//     pageviewTemplate (route) {
//       return {
//         page: route.path,
//         title: document.title,
//         location: window.location.href
//       }
//     }
//   }
// })

Vue.use(Meta)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js